<template>
  <div>
    <el-select
      v-model="source"
      :disabled="disabled"
      :placeholder="placeholder"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      source: "", // 当前被选择的来源渠道
      availableSources: [], // 所有可用的来源渠道
    };
  },

  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },

    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },

    // 是否支持选择“所有”
    enableAll: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    options() {
      let options = [];

      for (let source of this.availableSources) {
        options.push({
          value: source,
          label: source,
        });
      }

      // 添加“所有”选项
      if (this.enableAll) {
        options.push({
          value: "all",
          label: "所有",
        });
      }

      return options;
    },
  },

  created() {
    this.loadAvailableSources();
  },

  watch: {
    source: {
      handler(newValue, oldValue) {
        this.$emit("change", newValue, oldValue);
      },
    },
  },

  methods: {
    /**
     * 查询来源渠道集合
     */
    async loadAvailableSources() {
      this.availableSources = await bizutil.loadAvailableSources();

      // 抛出准备就绪事件
      this.$emit("ready");
    },
  },
};
</script>